import { Fragment, useEffect, useState } from "react"
import { connect } from "react-redux"

import { actions as configActions } from "../../redux/config"
import { Box, Grid, Link } from "@mui/material"
import { footerStyles } from "./styles"
import { getUserSelectedLanguage } from "../../constants/common-const"
import { ORDER_OF_LINKS_TO_SHOW_IN_FOOTER } from "../../constants/values"

const FooterSection = (props) => {
    const { getGlobalConfigurationData, globalConfigData } = props
    const [retryCount, setRetryCount] = useState(0)

    useEffect(() => {
        if (!globalConfigData || !globalConfigData.configData) {
            getGlobalConfigurationData()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    // Retry mechanism if footer config is missing
    useEffect(() => {
        if (!globalConfigData?.configData?.footer && retryCount < 3) {
            const timer = setTimeout(() => {
                getGlobalConfigurationData()
                setRetryCount((prev) => prev + 1)
            }, 2000)

            return () => clearTimeout(timer)
        }
    }, [globalConfigData, retryCount, getGlobalConfigurationData])

    // User selected language
    const userLanguage = getUserSelectedLanguage()
    const footerConfig = globalConfigData?.configData?.footer?.[userLanguage]
    if (!footerConfig) {
        return null
    }
    const { copyright, links } = footerConfig
    const browserYear = new Date().getFullYear()

    return (
        <Fragment>
            <Box
                component="footer"
                sx={footerStyles.footerContainer}
                data-test="footer-section"
            >
                <Grid
                    container
                    direction="row"
                    wrap="nowrap"
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <Grid
                        item
                        xs="auto"
                        sx={{
                            ...footerStyles.footerItem,
                            justifyContent: "flex-start",
                            textAlign: "left",
                        }}
                    >
                        <Box data-test="footer-content-div">
                            {copyright?.symbol} {browserYear}{" "}
                            {copyright?.company}&nbsp;
                            {copyright?.rightsText}
                        </Box>
                    </Grid>
                    <Grid
                        item
                        container
                        xs
                        direction="row"
                        wrap="nowrap"
                        justifyContent="flex-end"
                        alignItems="center"
                    >
                        {ORDER_OF_LINKS_TO_SHOW_IN_FOOTER.map((linkKey) => {
                            const linkData = links[linkKey]

                            if (!linkData) {
                                return null
                            }
                            return (
                                <Grid
                                    item
                                    key={linkKey}
                                    sx={footerStyles.footerItem}
                                >
                                    <Link
                                        sx={footerStyles.footerLink}
                                        target={
                                            linkData.openInNewTab
                                                ? "_blank"
                                                : "_self"
                                        }
                                        rel="noopener noreferrer"
                                        href={linkData.url}
                                        data-test={`footer-${linkKey}-link`}
                                    >
                                        <span>{linkData.label}</span>
                                    </Link>
                                </Grid>
                            )
                        })}
                    </Grid>
                </Grid>
            </Box>
        </Fragment>
    )
}

const mapStateToProps = (state) => ({
    globalConfigData: state.config.globalConfigData,
})

const mapDispatchToProps = {
    getGlobalConfigurationData: configActions.getGlobalConfigurationData,
}

export default connect(mapStateToProps, mapDispatchToProps)(FooterSection)
